module.exports = __webpack_public_path__ + "static/media/gallery04.f51d9759.png";